import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from './components/Login';
import LoginSelection from './components/LoginSelection';
import ChangePassword from './components/ChangePassword';



import Register from './components/Register';
import ForgotPassword from './components/ForgotPassword';
import ResetPasswordLink from './components/ResetPasswordLink';
import './App.css';
import { GoogleOAuthProvider } from '@react-oauth/google';
import VendorReuploadDashboard from './components/VendorReuploadDashboard';
import VendorFinalDashboard from './components/VendorFinalDashboard';

<GoogleOAuthProvider clientId="142524981824-4mrc83kdgpndreai60aiiapcijbk6f28.apps.googleusercontent.com">
  <App />
</GoogleOAuthProvider>

// Add this line to enable sending secure cookies
axios.defaults.withCredentials = true;

// ---------------- Axios instance with JWT interceptors ----------------
const api = axios.create({ baseURL: 'https://django-backend-115705416374.asia-south1.run.app', withCredentials: true });
// const api = axios.create({ baseURL: 'http://localhost:8000' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('access');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  async (error) => {
    const originalRequest = error.config;

    // Check if session was terminated by scheduler
    if (error.response?.status === 401) {
      const errorCode = error.response?.data?.code || error.response?.data?.detail?.code;
      const errorMessage = error.response?.data?.detail || error.response?.data?.message || '';

      // If session was terminated (by scheduler), immediately logout
      if (errorCode === 'session_terminated' || errorMessage.includes('session has been terminated')) {
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        localStorage.removeItem('session_id');
        localStorage.removeItem('vendor_login_type');
        // Redirect to login immediately
        window.location.href = '/';
        return Promise.reject(error);
      }

      // Try to refresh token for other 401 errors
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        const refresh = localStorage.getItem('refresh');
        if (refresh) {
          try {
            const res = await axios.post('https://django-backend-115705416374.asia-south1.run.app/api/token/refresh/', { refresh });
            // const res = await axios.post('http://localhost:8000/api/token/refresh/', { refresh });
            localStorage.setItem('access', res.data.access);
            originalRequest.headers.Authorization = `Bearer ${res.data.access}`;
            return api(originalRequest);
          } catch {
            // Refresh failed - clear tokens and redirect
            localStorage.removeItem('access');
            localStorage.removeItem('refresh');
            localStorage.removeItem('session_id');
            localStorage.removeItem('vendor_login_type');
            window.location.href = '/';
            return Promise.reject(error);
          }
        } else {
          // No refresh token - redirect to login
          localStorage.removeItem('access');
          localStorage.removeItem('refresh');
          localStorage.removeItem('session_id');
          localStorage.removeItem('vendor_login_type');
          window.location.href = '/';
        }
      }
    }
    return Promise.reject(error);
  }
);

function App() {
  const [token, setToken] = useState(localStorage.getItem('access') || null);
  const mustChangePassword = localStorage.getItem('mustChangePassword') === 'true';
  // Listen for auth logout events from API layer
  useEffect(() => {
    const handler = () => setToken(null);
    window.addEventListener('auth:logout', handler);
    return () => window.removeEventListener('auth:logout', handler);
  }, []);
  // eslint-disable-next-line no-unused-vars
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [captcha, setCaptcha] = useState(generateCaptcha());
  const [captchaInput, setCaptchaInput] = useState('');
  const [showRegister, setShowRegister] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [vendorHasReupload, setVendorHasReupload] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [vendorMilestoneStatus, setVendorMilestoneStatus] = useState(null);
  const [isEmployeeUser, setIsEmployeeUser] = useState(false);
  // Auto-open Register when vendor_code is present in URL
  useEffect(() => {
    try {
      const url = new URL(window.location.href);
      const vendorCode = url.searchParams.get('vendor_code');
      if (vendorCode) {
        setShowRegister(true);
      }
    } catch { }
  }, []);

  const [showForgot, setShowForgot] = useState(false);
  const [employees, setEmployees] = useState([]);
  const [formData, setFormData] = useState({ name: '', email: '', department: '' });
  const [forgotData, setForgotData] = useState({ email: '', pan: '' });
  const [vendorData, setVendorData] = useState({ firstName: '', lastName: '', gst: '', pan: '', OfficeAdd: '', personname: '', email: '', phonenumber: '' });
  const [vendorFiles, setVendorFiles] = useState({ gstCertificate: null, panCard: null, otherDocument: null });

  // ---------------- Captcha Generator ----------------
  function generateCaptcha() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    return Array.from({ length: 6 }, () => chars[Math.floor(Math.random() * chars.length)]).join('');
  }

  // ---------------- Fetch Employees ----------------
  const fetchEmployees = () => {
    api.get('/api/employees/')
      .then(res => setEmployees(res.data))
      .catch(err => {
        // Fetch employees error
      });
  };

  // ---------------- Login ----------------
  // eslint-disable-next-line no-unused-vars
  const login = () => {
    if (!credentials.username || !credentials.password || !captchaInput) {
      Swal.fire("All fields required!");
      return;
    }

    if (captchaInput !== captcha) {
      Swal.fire("Captcha does not match!");
      setCaptcha(generateCaptcha());
      setCaptchaInput('');
      return;
    }

    //   api.post('/api/token/', credentials)
    //     .then(res => {
    //       localStorage.setItem('access', res.data.access);
    //       localStorage.setItem('refresh', res.data.refresh);
    //       setToken(res.data.access);
    //     })
    //     .catch(err => {
    //       if (err.response && err.response.data?.temp_password_expired) {
    //         Swal.fire({
    //           icon: 'info',
    //           title: 'Temporary Password',
    //           text: err.response.data.message,
    //           confirmButtonText: 'Change Password'
    //         }).then(() => {
    //           window.location.href = '/reset-password';
    //         });
    //       } else {
    //         Swal.fire("Login failed");
    //       }
    //     });
    // };

    api.post('/api/token/', credentials)
      .then(res => {
        localStorage.setItem('access', res.data.access);
        localStorage.setItem('refresh', res.data.refresh);
        localStorage.setItem('session_id', res.data.session_id); // save session_id
        setToken(res.data.access);
        // After login, determine user role and vendor re-upload state
        (async () => {
          try {
            // Employee/staff permissions
            try {
              const permsRes = await api.get('/api/user-permissions/');
              const perms = permsRes.data || {};
              const isEmp = !!(perms.isSuperAdmin || perms.can_view || perms.can_design || perms.can_initiate || perms.can_approval || perms.can_status);
              setIsEmployeeUser(isEmp);
            } catch { setIsEmployeeUser(false); }

            // Vendor re-upload context
            try {
              const ctx = await api.get('/api/vendor/reupload-context/');
              const data = ctx.data || {};
              const has = Array.isArray(data.editable_doc_keys) && data.editable_doc_keys.length > 0;
              setVendorHasReupload(has);
              setVendorMilestoneStatus(data.milestone_status || null);
              if (has) setShowRegister(true);
            } catch {
              setVendorHasReupload(false);
              setVendorMilestoneStatus(null);
            }
          } catch { }
        })();
      })
      .catch(err => {
        if (err.response?.status === 409 && err.response.data.error === "Active Session") {
          Swal.fire("⚠️ Active session already exists. Please logout from other device/tab.");
        } else if (err.response?.status === 401) {
          Swal.fire("Invalid credentials!");
        } else {
          Swal.fire("Login failed!");
        }
      });
  };



  // ---------------- Idle Session Logout (15 min) ----------------
  useEffect(() => {
    if (!token) return;

    let timer;
    const resetTimer = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(async () => {
        try {
          await api.post('/api/logout/', { logout_reason: 'auto' });   // 🔹 tell backend to remove session_id (auto logout)
        } catch (err) {
          // Logout API failed
        }
        localStorage.removeItem('access');
        localStorage.removeItem('refresh');
        setToken(null);
        Swal.fire({
          icon: 'info',
          title: 'Session Timeout',
          text: 'You have been logged out due to inactivity.'
        });
      }, 900000); // 15 minute
    };

    const events = ['mousemove', 'mousedown', 'keypress', 'scroll', 'touchstart'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      clearTimeout(timer);
      events.forEach(event => window.removeEventListener(event, resetTimer));
    };
  }, [token]);

  // ---------------- JSX Render with React Router ----------------
  //   return (
  //     <Router>
  //       <Routes>
  //         {/* Reset Password Route */}
  //         <Route path="/reset-password" element={<ResetPasswordLink />} />

  //             {/* Default App Route */}
  //             <Route
  //               path="/*"
  //               element={
  //                 <div>
  //                   {!token ? (
  //                     showRegister ? (
  //                       <Register 
  //                         onBack={() => setShowRegister(false)} 
  //                         api={api}
  //                       />
  //                     ) : showForgot ? (
  //                       <ForgotPassword 
  //                         forgotData={forgotData} setForgotData={setForgotData} 
  //                         onBack={() => setShowForgot(false)} 
  //                       />
  //                     ) : (
  //                       <LoginSelection
  //                         onShowRegister={() => setShowRegister(true)}
  //                         onShowForgot={() => setShowForgot(true)}
  //                       />
  //                     )
  //                   ) : (
  //                     isEmployeeUser ? (
  //                       <EmployeeDashboard
  //                         employees={employees} fetchEmployees={fetchEmployees}
  //                         formData={formData} setFormData={setFormData} api={api}
  //                       />
  //                     ) : (
  //                       <VendorDashboard
  //                         vendorData={vendorData} setVendorData={setVendorData}
  //                         vendorFiles={vendorFiles} setVendorFiles={setVendorFiles}
  //                         api={api}
  //                       />
  //                     )
  //                   )}
  //                 </div>
  //               }
  //             />      
  //       </Routes>
  //     </Router>
  //   );
  // }

  // export default App;


  // 🚫 If user must change password, show only that screen
  if (mustChangePassword) {
    return (
      <div className="container">
        <ChangePassword />
      </div>
    );
  }


  return (
    <Router>
      <Routes>
        {/* Reset Password Route */}
        <Route path="/reset-password" element={<ResetPasswordLink />} />

        {/* Default App Route */}
        <Route
          path="/*"
          element={
            <div className={token && !isEmployeeUser && localStorage.getItem('vendor_login_type') !== 'reupload' ? "" : "container"}>
              {!token ? (
                showRegister ? (
                  <Register
                    vendorData={vendorData} setVendorData={setVendorData}
                    vendorFiles={vendorFiles} setVendorFiles={setVendorFiles}
                    onBack={() => setShowRegister(false)}
                  />
                ) : showForgot ? (
                  <ForgotPassword
                    forgotData={forgotData} setForgotData={setForgotData}
                    onBack={() => setShowForgot(false)}
                  />
                ) : (
                  <LoginSelection
                    onShowRegister={() => setShowRegister(true)}
                    onShowForgot={() => setShowForgot(true)}
                  />
                )
              ) : (
                // Determine which vendor dashboard to show based on login_type
                (() => {
                  const loginType = localStorage.getItem('vendor_login_type');

                  if (loginType === 'reupload') {
                    // Re-upload login: Show reupload dashboard (only Form tab with ReuploadForm)
                    return (
                      <VendorReuploadDashboard
                        vendorData={vendorData} setVendorData={setVendorData}
                        vendorFiles={vendorFiles} setVendorFiles={setVendorFiles}
                        api={api}
                      />
                    );
                  } else {
                    // Final login: Show final dashboard (only Home tab, no Form tab)
                    // VendorFinalDashboard will handle showing company selector if needed
                    return (
                      <VendorFinalDashboard
                        vendorData={vendorData} setVendorData={setVendorData}
                        vendorFiles={vendorFiles} setVendorFiles={setVendorFiles}
                        api={api}
                      />
                    );
                  }
                })()
              )}
            </div>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;


